import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=1f828fa0"
import script from "./ViewOrder.vue?vue&type=script&lang=js"
export * from "./ViewOrder.vue?vue&type=script&lang=js"
import style0 from "./ViewOrder.vue?vue&type=style&index=0&id=1f828fa0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f828fa0')) {
      api.createRecord('1f828fa0', component.options)
    } else {
      api.reload('1f828fa0', component.options)
    }
    module.hot.accept("./ViewOrder.vue?vue&type=template&id=1f828fa0", function () {
      api.rerender('1f828fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ViewOrder.vue"
export default component.exports